'use client';

import { cn, DEMO_TRADING_HELP_URL } from 'common/utils';
import { WarningIcon } from 'components/v2/atoms/icon';

interface DemoWarningBannerProps {
  className?: string;
}

const DemoWarningBanner = ({ className }: DemoWarningBannerProps) => {
  return (
    <div
      className={cn(
        'mb-5 flex items-start gap-3 rounded-xl border border-warning-orange-primary p-4',
        className,
      )}
      style={{
        background: 'linear-gradient(135deg, #FFF9E5 0%, #FFF3CD 100%)',
      }}
    >
      <WarningIcon color="#f59e0b" width={21} height={21} />
      <div className="flex-1">
        <div className="mb-1 text-sm font-semibold text-pp-text-primary">
          デモトレード環境です
        </div>
        <div className="text-xs leading-relaxed text-pp-text-secondary">
          このポートフォリオは仮想資金によるデモトレードです。表示される価格、損益、リターンはすべてシミュレーションによるもので、実際の金銭取引は発生しません。
          <br />
          <span>
            詳しくは
            <a
              href={DEMO_TRADING_HELP_URL}
              target="_blank"
              className="font-bold underline"
              rel="noopener noreferrer"
            >
              こちら
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default DemoWarningBanner;
